<template>
    <PriceIndicator
        :price-hidden="priceHidden"
        :is-strategy-profile="isStrategyProfile"
        :edit-mode="true"
        :currency-code="currencyCode"
        :price="price"
    >
        <template #price-hidden>
            <VJoyTooltip v-if="priceHidden" placement="bottom" class="price-indicator__tooltip">
                <VJoyIcon name="eye-masked" color="neutral-50" class="price-indicator__tooltip-icon" data-testid="profile-edit-price-not-visible" />
                <template #tooltip-content>
                    {{ $t('profile.numeral.infos.price.mine.non.visible') }}
                </template>
            </VJoyTooltip>
        </template>
    </PriceIndicator>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyTooltip} from '@maltjoy/core-vue';
    import PriceIndicator from './PriceIndicator.vue';

    defineProps<{
        priceHidden?: boolean;
        currencyCode: string;
        price: number;
        isStrategyProfile: boolean;
    }>();
</script>
<style scoped lang="scss">
    .price-indicator {
        &__tooltip {
            height: 16px;
        }

        &__tooltip-icon {
            cursor: pointer;
        }
    }
</style>
